import React, { ReactNode } from 'react';
import cn from 'classnames';
import { Button, ButtonProps } from '../Button';
import './Card.css';

export interface CardProps {
  /**
   * Title to be displayed above the card contents
   */
  title?: string;
  /**
   * Icon buttons in the card header on the right hand
   * side.
   */
  headerActions?: ButtonProps[];
  /**
   * Additional css class name to be applied to the card
   * component.
   */
  className?: string;
  children?: ReactNode;
}

/**
 * Generic card component, which respects the MNSPro UI
 * guidelines and smartphone use.
 */
export const Card: React.FC<CardProps> = ({
  title,
  children,
  headerActions,
  className,
}) => {
  return (
    <div className={cn('card', className)}>
      {(title || headerActions) && (
        <div className="cardHead">
          {title && <h2 className="title">{title}</h2>}
          {headerActions && (
            <div className="flex gap-2">
              {headerActions.map((action, index) => (
                <Button key={index} {...action} appearance="transparent" size="small" />
              ))}
            </div>
          )}
        </div>
      )}
      <div className="cardContent">{children}</div>
    </div>
  );
};
